import { Box, Checkbox, Collapse, FormControlLabel } from '@mui/material';
import { Controller, FormProvider, useForm } from 'react-hook-form';

import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput';
import CustomFormSelect from 'components/inputs/CustomFormSelect/CustomFormSelect';

import { filterUserRolesList, filterUserStatusList } from 'common/constants';
import { ProductSuggestionsFilterDto } from 'types/dto/ProductSuggestionsFilterDto';

interface Props {
  open: boolean;
  initialValues: ProductSuggestionsFilterDto;
  loading: boolean;
  onApply: (filters: ProductSuggestionsFilterDto) => void;
  onReset: () => void;
}

export default function ProductSuggestionsFilters({
  open,
  initialValues,
  loading,
  onApply,
  onReset,
}: Props) {
  const methods = useForm<ProductSuggestionsFilterDto>({
    defaultValues: initialValues,
  });

  const { handleSubmit, reset } = methods;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        sx={{
          px: 2,
          py: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(onApply)}
            display="grid"
            gridTemplateColumns={{ xs: '1fr', md: 'repeat(4, 1fr)' }}
            gap={2}
            flex={1}
          >
            {/* Suggestion ID */}
            <CustomFormTextInput
              name="id"
              floatingLabel='Suggestion ID'
              register={methods.register}
            />

            {/* Barcode */}
            <CustomFormTextInput
              name="barcode"
              floatingLabel='Barcode'
              register={methods.register}
            />

            {/* Empty Category */}
            <Box display="flex" alignItems="center">
              <Controller
                name="emptyCategory"
                control={methods.control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="Empty Category"
                  />
                )}
              />
            </Box>

            {/* Actions */}
            <Box
              display="flex"
              gap={1}
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{
                alignSelf: 'end',
              }}
            >
              <CustomButton
                fullWidth
                text="Reset"
                variant="outlined"
                height={40}
                disabled={loading}
                onClick={() => {
                  reset();
                  onReset();
                }}
              />
              <CustomButton
                fullWidth
                text="Search"
                type="submit"
                height={40}
                loading={loading}
              />
            </Box>
          </Box>
        </FormProvider>
      </Box>
    </Collapse>
  );
}
